import React, { useState, useEffect } from 'react';
import { IconFont } from '@features/common';
import './ShowInfo.less';

export interface IItem {
  icon: string;
  num: number;
  des: string;
}

export interface IShowInfoProps {
  list: IItem[];
}
type Props = IShowInfoProps;

export function ShowInfo(props: Readonly<Props>) {
  const { list } = props;
  const length = list.length;

  return (
    <div className="common-presenter k-common-show-info">
      {list.map((item, index) => (
        <React.Fragment key={index}>
          <IconFont type={item.icon} className="info__ico" />
          {item.num} {item.des}
          {index < length - 1 && <span className="info__line" />}
        </React.Fragment>
      ))}
    </div>
  );
}

export default ShowInfo;
